// Which service a booking belongs to, for lists that mix them (assign driver, driver jobs):
// a local delivery (Shop order, delivered in the pickup country) or an international booking (sea / air).
const COLORS = {
  local: { background: "#ccfbf1", color: "#0f766e" },
  sea: { background: "#dbeafe", color: "#1d4ed8" },
  air: { background: "#ede9fe", color: "#6d28d9" },
};

const ServiceTag = ({ booking, style }) => {
  const isLocal = parseInt(booking?.is_delivery) === 1;
  const kind = isLocal ? "local" : booking?.freight_type === "Air Freight" ? "air" : "sea";
  const label = isLocal ? "Shop Order" : kind === "air" ? "Air" : "Sea";

  return (<span
    title={isLocal ? "Shop order, delivered in the pickup country" : `International booking (${booking?.freight_type || "Sea Freight"})`}
    style={{
      display: "inline-block",
      marginLeft: 6,
      padding: "2px 8px",
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 600,
      fontFamily: "inherit",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      ...COLORS[kind],
      ...style,
    }}
  >{label}</span>);
};

export default ServiceTag;
